module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c4223869e4bb0a1a956fba19c968cfa0.png";